import React from 'react';

var MasonryLayout = function MasonryLayout() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("rect", {
    x: "0.5",
    y: "0.5",
    width: "31",
    height: "31",
    rx: "0.5",
    fill: "white",
    stroke: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "2",
    width: "8",
    height: "12",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "15",
    width: "8",
    height: "5",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "8",
    width: "8",
    height: "7",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "10",
    width: "8",
    height: "5",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "17",
    width: "8",
    height: "13",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "2",
    y: "22",
    width: "8",
    height: "8",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "17",
    width: "8",
    height: "13",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "22",
    y: "2",
    width: "8",
    height: "7",
    fill: "#444749"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "2",
    width: "8",
    height: "4",
    fill: "#444749"
  }));
};

export default MasonryLayout;